import React from "react";
import { Box, Button, Tooltip, CircularProgress } from "@mui/material";
import { Save as SaveIcon, Delete as DeleteIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material";

const ReviewHeaderActions = ({
  isDraft,
  isSubmitting,
  isDiscarding,
  shouldDisableActions,
  isSystemArchived,
  isDraftAndNotOwner,
  allUsersReviewed,
  submitValidationMessage,
  onSubmit,
  onDiscard,
}) => {
  const theme = useTheme();

  if (!isDraft) return null;

  const getTooltipMessage = () => {
    if (isSystemArchived) {
      return "System is archived. Activate it to start a review.";
    }
    if (isDraftAndNotOwner) {
      return "You are not an owner of the system";
    }
    if (submitValidationMessage) {
      return submitValidationMessage;
    }
    return "";
  };

  const tooltipMessage = getTooltipMessage();

  return (
    <Box sx={{ display: "flex", gap: 2 }}>
      <Tooltip title={tooltipMessage} arrow>
        <span>
          <Button
            size="small"
            variant="outlined"
            startIcon={<DeleteIcon sx={{ fontSize: 16 }} />}
            onClick={onDiscard}
            disabled={isDiscarding || shouldDisableActions}
            sx={{
              fontWeight: 500,
              borderRadius: "8px",
              textTransform: "none",
              fontSize: "14px",
              px: 2,
              py: 1,
              borderColor: theme.customColors?.status?.error?.main || "#D32F2F",
              color: theme.customColors?.status?.error?.main || "#D32F2F",
              "&:hover": {
                borderColor: theme.customColors?.status?.error?.text || "#B71C1C",
                backgroundColor: theme.customColors?.status?.error?.bg || "#FFEBEE",
                color: theme.customColors?.status?.error?.text || "#B71C1C",
              },
              "&:disabled": {
                borderColor: theme.customColors?.status?.error?.main || "#D32F2F",
                opacity: 0.5,
              },
            }}
          >
            Discard
            {isDiscarding && (
              <CircularProgress
                size={16}
                sx={{
                  color: theme.customColors?.status?.error?.main || "#D32F2F",
                  ml: 1,
                }}
              />
            )}
          </Button>
        </span>
      </Tooltip>
      <Tooltip title={tooltipMessage} arrow>
        <span>
          <Button
            size="small"
            variant="contained"
            startIcon={<SaveIcon sx={{ fontSize: 16 }} />}
            onClick={onSubmit}
            disabled={!allUsersReviewed || isSubmitting || shouldDisableActions}
            sx={{
              backgroundColor: theme.customColors?.button?.dark || "#031B89",
              color: theme.customColors?.button?.text || "#FFFFFF",
              fontWeight: 500,
              borderRadius: "8px",
              textTransform: "none",
              fontSize: "14px",
              px: 2,
              py: 1,
              "&:hover": {
                backgroundColor: theme.customColors?.button?.hover || "#021569",
              },
              "&:disabled": {
                backgroundColor: theme.customColors?.button?.dark || "#031B89",
                opacity: 0.5,
              },
            }}
          >
            Submit
            {isSubmitting && (
              <CircularProgress
                size={20}
                sx={{
                  color: theme.customColors?.text?.disabled || "#FFFFFF",
                  ml: 1,
                }}
              />
            )}
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
};

export default ReviewHeaderActions;

